module.exports = __webpack_public_path__ + "static/media/banner.332d8f81.png";